import { FC } from 'react';
import { SkeletonFrame, SkeletonType, useBreakpoint, Breakpoints } from '@nextgen-web-framework/all';
import type { SearchCardLoaderPropsTypes } from './types/propsTypes';
import styles from './SearchCardLoader.module.scss';

const SearchCardLoader: FC<SearchCardLoaderPropsTypes> = ({
  className = '',
  isFlexibleWidthCard = false,
}: SearchCardLoaderPropsTypes): JSX.Element => {
  const dim = { heightValue: '195', widhtValue: isFlexibleWidthCard ? '100%' : '180' };
  let isMobile = false;
  const viewportType = useBreakpoint();
  if ([Breakpoints.SM, Breakpoints.XS].includes(viewportType as Breakpoints)) {
    dim.heightValue = '132';
    dim.widhtValue = '132';
    isMobile = true;
  } else {
    dim.heightValue = '195';
    dim.widhtValue = '180';
    isMobile = false;
  }
  if (isFlexibleWidthCard) {
    dim.widhtValue = '100%';
  }

  const getMobileHeight = (height: string) => (isMobile ? '18' : height);

  return (
    <div
      className={`${styles['search-card-loader-container']} ${className} ${
        isFlexibleWidthCard && styles['flexible-card-width']
      }`}
      data-testid="search-card-loader"
    >
      <div className={styles['search-card-loader-image']}>
        <SkeletonFrame {...dim} isRoundCorner type={SkeletonType.IMAGE_PANEL} />
      </div>
      <div className={styles['search-card-loader-detail']}>
        <div className={styles['search-card-loader-detail-child']}>
          <SkeletonFrame borderRadiusValue="4" heightValue={getMobileHeight('24')} isRoundCorner widthValue="77" />
          <SkeletonFrame borderRadiusValue="4" heightValue={getMobileHeight('22')} isRoundCorner widthValue="100%" />
          <SkeletonFrame
            borderRadiusValue="4"
            heightValue={getMobileHeight('24')}
            isRoundCorner
            widthValue={isFlexibleWidthCard && isMobile ? '77' : '117'}
          />
        </div>
        <div className={styles['search-card-loader-detail-child']}>
          {!isMobile && (
            <SkeletonFrame
              borderRadiusValue="4"
              heightValue="24"
              isRoundCorner
              widthValue={isFlexibleWidthCard ? '100%' : '192'}
            />
          )}
          <SkeletonFrame borderRadiusValue="4" heightValue="24" isRoundCorner widthValue="77" />
        </div>
        <div className={styles['search-card-loader-detail-child']}>
          <SkeletonFrame isRoundCorner type={SkeletonType.BUTTON} heightValue="36" />
        </div>
      </div>
    </div>
  );
};

export default SearchCardLoader;
export type { SearchCardLoaderPropsTypes };
